import { unstable_useCompatEffect } from '@formily/reactive-react';
export var useAttach = function (target) {
    unstable_useCompatEffect(function () {
        target.onMount();
        return function () { return target.onUnmount(); };
    }, [target]);
    return target;
};
//# sourceMappingURL=useAttach.js.map